import React from 'react';
const StoreCreditOrderHistory = props => {
  const {
    currencyMark,
    userInfo,
    orderHistory,
    dataLocale: { ORDER, DATE_TIME, AMOUNT, COMMENTS, EXTRA_CONTENT, CURRENCY_CODE },
  } = props;
  const currencyCode =
    userInfo && userInfo.result ? userInfo.result.loyaltyOrder.currencyCode : CURRENCY_CODE;
  const currencySymbol = currencyMark[currencyCode];
  return (
    <div className="sc-order-list">
      <table className="table table-striped">
        <thead className="thead-light">
          <tr>
            <th scope="col" style={{ width: '12%' }}>
              {ORDER}
            </th>
            <th scope="col" style={{ width: '22%' }}>
              {DATE_TIME}
            </th>
            <th scope="col" style={{ width: '10%' }}>
              {AMOUNT}
            </th>
            <th scope="col">{COMMENTS}</th>
            <th scope="col">{EXTRA_CONTENT}</th>
          </tr>
        </thead>
        <tbody>
          {orderHistory &&
            orderHistory.map(order => (
              <tr key={order.createdAt}>
                <th scope="row">{order.orderIncrementId}</th>
                <td>{new Date(order.createdAt).toString().slice(0, 24)}</td>
                <td>
                  {currencySymbol} {order.amount}
                </td>
                <td>{order.comments}</td>
                <td>{order.extraContent}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default StoreCreditOrderHistory;
